import { DraftState } from '@/types';
import { isOneSizeProductType } from '@/model/productType/isOneSizeProductType';

export type PartialDraft = Pick<DraftState, 'productType' | 'appearance' | 'view'> &
  Partial<DraftState>;

export const setDraftAction =
  ({
    productType,
    appearance,
    view,
    configurationIds = [],
    configurations = {},
    selectedConfigurationId = -1,
    selectedSizes = isOneSizeProductType(productType) ? { [productType.sizes[0].id]: 1 } : {},
    basketItemId,
    validation: { valid, errors } = {
      valid: true,
      errors: {},
    },
    warnings = {},
  }: PartialDraft) =>
  (draft: DraftState) => {
    Object.assign(draft, {
      productType,
      appearance,
      view,
      configurationIds,
      configurations,
      selectedConfigurationId,
      selectedSizes,
      basketItemId,
      validation: {
        valid,
        errors,
      },
      warnings,
    });
  };
